/**
 * MongoDB collection names as defined in the backend appsettings. These match
 * the `collection` field in IApiChange entries returned by write endpoints, and
 * are used to identify which documents were affected in a transaction.
 *
 * When a new cascade relationship is added (e.g. OP-2581 Input), add the
 * corresponding collection name here.
 */
export const FARM_COLLECTION = "Farm";
export const ZONE_COLLECTION = "Zone";
